export const DEFAULT_ENFORCEMENT_EXCLUSIVE_FIELDS = [
  'agencies',
  'enforcement',
  'id',
  'publication_date'
];
